import React, {Component} from 'react';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import {Route, Redirect, Switch} from 'react-router-dom';
import GareList from './GareList'
import GareForm from './GareForm'

class GareContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (<div>
            <Switch>
                <Route exact path='/app/gare' render={() => (
                    <Redirect
                        to='/app/gare/list'
                    />
                )} />
                <MatchWhenLoggedIn path='/app/gare/list' component={GareList} />
                <MatchWhenLoggedIn path='/app/gare/edit/:id' component={GareForm} />
                <MatchWhenLoggedIn path='/app/gare/view/:id' component={GareForm} />
                <MatchWhenLoggedIn path='/app/gare/new' component={GareForm} />
            </Switch>
        </div>)
    }
}

export default GareContent;




/** WEBPACK FOOTER **
 ** ./src/components/gare/GareContent.js
 **/